import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ContentModerationLayer from "../components/ContentModerationLayer";

const ContentModerationPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Content & Feedback" />
        <ContentModerationLayer />
      </MasterLayout>
    </>
  );
};

export default ContentModerationPage;
